import React from 'react';

export default class ContactMap extends React.Component {
    render(){
        return (
            <>

                <section className="google-map">
                    <iframe
                    title="Map"
                    src="https://www.google.com/maps?q=Niku%20Solutions%20PTE%20LTD%20133%20New%20Bridge%20Road%20%2310-03%20Chinatown%20Point%20Singapore%20521147&z=16&output=embed"
                    className="google-map__one" allowfullscreen></iframe>
                </section>
            </>
        )
    }
}